<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Pre-2004 Jumps Adjustment</span>
</div>
<app-form
  class="edit-pre2004jumps-form"
  [sections]="sections"
  [data]="pre2004JumpsAdjustments"
  [mode]="mode"
  cancel="pre2004jumps"
  (submitted)="submitForm($event)"
></app-form>
